import OutOfStockBlock from './OutOfStockBlock.vue'

export default OutOfStockBlock
